/**
 * Alan adı taşıması sonrası dayanıklılık önlemleri.
 *
 * 1. Eski sitenin (aynı alan adında yayındaki önceki altyapı) ziyaretçi
 *    tarayıcılarında bıraktığı service worker ve Cache Storage kayıtları,
 *    yeni sitenin isteklerine karışabiliyor. Tek seferlik temizlik yapılır.
 *
 * 2. Mobil/hücresel ağlarda görsel istekleri ara sıra geçici olarak
 *    başarısız olabiliyor (özellikle iOS Safari). Başarısız olan <img>
 *    bir kez, kısa gecikmeyle ve önbellek kırıcıyla yeniden denenir.
 */

export function cleanupLegacyServiceWorkers(): void {
  try {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    if (typeof caches !== "undefined" && caches?.keys) {
      caches
        .keys()
        .then((keys) => keys.forEach((k) => caches.delete(k)))
        .catch(() => {});
    }
  } catch {
    /* eski tarayıcılar: sessizce geç */
  }
}

const RETRY_DELAY_MS = 1200;

export function installImageRetry(): void {
  window.addEventListener(
    "error",
    (event) => {
      const el = event.target as HTMLElement | null;
      if (!el || el.tagName !== "IMG") return;
      const img = el as HTMLImageElement;
      // Yalnızca kendi medya depomuzdan gelen görselleri, bir kez dene
      const ownMedia = img.src.includes("/media/") || img.src.includes("firebasestorage.googleapis.com");
      if (img.dataset.retried || !ownMedia) return;
      img.dataset.retried = "1";
      const original = img.src;
      window.setTimeout(() => {
        img.src = original + (original.includes("?") ? "&" : "?") + "r=" + Date.now();
      }, RETRY_DELAY_MS);
    },
    true // capture: <img> error olayları bubble etmez
  );
}
